const DID_MOUNT = 'didMount';
const FOCUS = 'focus';

export { DID_MOUNT, FOCUS };
